export default "__VITE_ASSET__BsNxFvUC__"